import { useNavigate } from 'react-router-dom';

import Button from 'components/shared/Buttons/Button';

const HeaderActions = () => {
  const navigate = useNavigate();

  const redirectToNewPractitioner = () => {
    navigate('/admin/practitioners/new');
  };
  return (
    <div className="flex items-center gap-2">
      <Button
        text="New Practitioner"
        icon="add-square-mono"
        size="small"
        transparent
        iconColor="white"
        onClick={() => redirectToNewPractitioner()}
        textClassName="whitespace-nowrap"
      />
    </div>
  );
};

export default HeaderActions;
